module.exports = __webpack_public_path__ + "static/media/14.b833fc00.jpg";